import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { MainTitle } from "../../Utils/Constants.";
import { Link } from "react-router-dom";
import ExportZoneNetworkExcelSheet from "./ExportZoneNetworkExcelSheet";

const LABEL = { color: "#864797", fontWeight: 700 };

// value or "-" when empty
const show = (v) => (v ? v : "-");

/**
//    * @component  Zone  Configuration Component
//    * @description  Zone configuration header and details card (E5 design): "← Zone Overview" + title,
//    * Export + ⋯ on the right, then a white card with Name / Zone Number / Time Zone and the paths.
//    * @returns Zone  configuration  UI
//    */
const ZoneConfiguration = (props) => {
  const zone = props.zoneData || {};
  const timeZone =
    zone.timeZoneDetails &&
    (zone.timeZoneDetails.displayName || zone.timeZoneDetails.displayText);

  return (
    <div className="stickyDiv">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: "20px",
          "& .exportBtn": { float: "none", margin: "0 !important" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <Link
            to="/home"
            aria-label="Back to Zone Overview"
            style={{ color: "#864797", fontSize: 12, textDecoration: "none" }}
          >
            ← Zone Overview
          </Link>
          <MainTitle title="Zone Configuration" />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
          <ExportZoneNetworkExcelSheet
            id={zone.id ? zone.id : 1}
            setShowMsgComp={props.setShowMsgComp}
            setMsgContent={props.setMsgContent}
            exportDisable={props.exportDisable}
          />
          {props.actions}
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 1px 4px rgba(16,24,40,.12)",
          p: "16px 16px 20px",
          mb: "36px",
          color: "#202020",
          textAlign: "left",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#eeeef4",
            borderRadius: "8px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            p: "12px 16px",
            fontSize: 13,
            mb: "12px",
          }}
        >
          <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            <span style={LABEL}>Name : </span>
            {show(zone.zoneName)}
          </Box>
          <Box>
            <span style={LABEL}>Zone Number : </span>
            {show(zone.zoneNumber)}
          </Box>
          <Box>
            <span style={LABEL}>Time Zone : </span>
            {show(timeZone)}
          </Box>
        </Box>
        <Box sx={{ p: "12px 16px", fontSize: 12, borderBottom: "1px solid #d9d9df" }}>
          <span style={LABEL}>SCH Path : </span>
          {show(zone.scheduleFileBasePath)}
        </Box>
        <Box sx={{ p: "14px 16px 4px", fontSize: 12 }}>
          <span style={LABEL}>VER Path : </span>
          {show(zone.verificationFileBasePath)}
        </Box>
      </Box>
    </div>
  );
};

ZoneConfiguration.propTypes = {
  zoneData: PropTypes.object,
  actions: PropTypes.node,
};

export default ZoneConfiguration;
